import React from 'react';
import { privacyPolicyEn } from '../../content/legal/privacyPolicy.en';
import styles from './PrivacyPolicy.module.css';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className={styles.privacy}>
      <div className={styles.container}>
        <div className={styles.panel}>
          <header className={styles.header}>
            <h1 className={styles.title}>{privacyPolicyEn.title}</h1>
            <p className={styles.subtitle}>
              <strong>Last Updated:</strong> {privacyPolicyEn.lastUpdated}
            </p>
          </header>

          <div className={styles.content}>
            {privacyPolicyEn.sections.map((section) => (
              <section key={section.heading}>
                <h2>{section.heading}</h2>
                {section.subheading && <h3>{section.subheading}</h3>}
                {section.blocks.map((block, idx) => {
                  if (block.type === 'p') {
                    return <p key={`${section.heading}-p-${idx}`}>{block.text}</p>;
                  }

                  return (
                    <ul key={`${section.heading}-ul-${idx}`}>
                      {block.items.map((item) => (
                        <li key={`${item.label ?? 'item'}-${item.text}`}>
                          {item.label ? (
                            <>
                              <strong>{item.label}</strong>: {item.text}
                            </>
                          ) : (
                            item.text
                          )}
                        </li>
                      ))}
                    </ul>
                  );
                })}
              </section>
            ))}

            <hr className={styles.hr} />

            <footer className={styles.footer}>
              <p>
                <em>{privacyPolicyEn.footerNote}</em>
              </p>
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
